// Guard against re-declaration during hot reload
if (!customElements.get('tooltip-modal')) {
  class Tooltip extends HTMLElement {
    constructor() {
      super();
      this.tooltipButton = this.querySelector('.tooltip__button');
      this.tooltipContent = this.querySelector('.tooltip__content');
      this.hideTimeout = null;
    }

    connectedCallback() {
      // Show tooltip on button hover
      this.tooltipButton?.addEventListener('mouseenter', () => {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }

        // Close all other open tooltips
        document.querySelectorAll('tooltip-modal.tooltip--active').forEach((tooltip) => {
          if (tooltip !== this) {
            tooltip.classList.remove('tooltip--active');
          }
        });

        // Open tooltip
        this.classList.add('tooltip--active');
        this.keepContentInViewport();
      });

      // Keep tooltip open when hovering over the button
      this.tooltipButton?.addEventListener('mouseleave', () => {
        this.hideTimeout = setTimeout(() => {
          this.classList.remove('tooltip--active');
        }, 200);
      });

      // Keep tooltip open when hovering over the content
      this.tooltipContent?.addEventListener('mouseenter', () => {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
      });

      // Hide tooltip when leaving the content
      this.tooltipContent?.addEventListener('mouseleave', () => {
        this.hideTimeout = setTimeout(() => {
          this.classList.remove('tooltip--active');
        }, 200);
      });
    }

    // Shift content horizontally if it would overflow the viewport edges
    keepContentInViewport() {
      if (!this.tooltipContent) return;

      this.tooltipContent.style.translate = '';
      const gutter = 16;
      const rect = this.tooltipContent.getBoundingClientRect();
      let shift = 0;

      if (rect.right > window.innerWidth - gutter) shift = window.innerWidth - gutter - rect.right;
      if (rect.left + shift < gutter) shift = gutter - rect.left;

      if (shift) this.tooltipContent.style.translate = `${shift}px 0`;
    }
  }

  customElements.define('tooltip-modal', Tooltip);
}